import React, { useEffect, useState } from "react";
import styles from './OrdersEquipment.module.scss';
import { HTTPMethod, callApi as patientRequest } from "../../../services/HttpService/HttpService";
import { LocationStateApi, OrdersComponentApi } from "../../../../src/constants/ApiConstants";
import NoData from "../../../components/noData/noData";
import EquipmentListSkeleton from "./EquipmentListSkeleton";
import { Box, Card, List, ListItem, Stack, Typography, Grid, Tooltip, useMediaQuery, IconButton, Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import CommonAlert from "../../../components/common-alert/common-alert";
import { successToast } from "../../../components/ToastMessage/ToastMessage";
import GenericEquipmentTags from "../../../common/Utils/GenericEquipmentTags/GenericEquipmentTags";
import { commonConstants } from "../../../common/constants";
import { ImageToggle } from "../../../common/ImageToggle/ImageToggle";
import { useSelector } from "react-redux";
import { OrderReasonUpdatedEnum, orderStatus } from "../../../common/enums";
import Panel from "../../../components/Panel/Panel";
import Icon from "../../../components/Icon/Icon";
import StatusBadge from "../../../components/StatusBadge/StatusBadge";
import ItemLabel from "../../../components/ItemLabel/ItemLabel";

export const GenericEquipmentItemDetails = ({ item, orderStatus, t, serviceOrderEquipment, pickupOrderEquipment, equipmentDataForOrders }) => {

  return (
    <Stack>
      {item.orders && (
        <ItemLabel label={t("EquipmentsTab.order")}>
          <Link href="#">{item.orders}</Link>
        </ItemLabel>
      )}
      {item.quantity && <ItemLabel label="Quantity" text={item.quantity} />}
      {item.provider && <ItemLabel label={t("EquipmentsTab.provider")} text={item.provider} />}
      {item.asset_tag && <ItemLabel label={t("EquipmentsTab.asset")} text={item.asset_tag} />}
      {item.serial_number && <ItemLabel label={t("EquipmentsTab.serial")} text={item.serial_number} />}
      {item.lot_number && <ItemLabel label={t("EquipmentsTab.lot")} text={item.lot_number} />}
      {item.approved_on !== commonConstants.defaultDateTime && item.approved_on && (
        <ItemLabel label={t("EquipmentsTab.approvedOn")} text={item.approved_on} />
      )}
      {item.approved_by && <ItemLabel label={t("EquipmentsTab.approvedBy")} text={item.approved_by} />}
      {item.rejected_on !== commonConstants.defaultDateTime && item.rejected_on && orderStatus === "Rejected" && (
        <ItemLabel label="Rejected on" text={item.rejected_on} />
      )}
      {item.rejected_by && orderStatus === "Rejected" && (
        <ItemLabel label="Rejected by" text={item.rejected_by} />
      )}
      {(equipmentDataForOrders && ((item.delivered_on != null && item.delivered_on != commonConstants.defaultDateTime) || (item.deliver_by != null && item.deliver_by != commonConstants.defaultDateTime))) && item.equipment_complete_status == "Delivered" && (
        <ItemLabel label={t("EquipmentsTab.deliveredOn")} text={item.delivered_on} />
      )}
      {(equipmentDataForOrders && ((item.delivered_on != null && item.delivered_on != commonConstants.defaultDateTime) || (item.deliver_by != null && item.deliver_by != commonConstants.defaultDateTime) || (item.service_by != null && item.service_by != commonConstants.defaultDateTime))) && item.equipment_complete_status != "Delivered" && (
        <ItemLabel label={t("Dashboard.deliverBy")} text={item.deliver_by ? item.deliver_by : item.service_by} />
      )}
      {(pickupOrderEquipment && ((item.picked_up_on != null && item.picked_up_on != commonConstants.defaultDateTime) || (item.delivered_on != null && item.delivered_on != commonConstants.defaultDateTime) || (item.pickup_by != null && item.pickup_by != commonConstants.defaultDateTime))) && (
        <>
          {item.delivered_on && <ItemLabel label={t("EquipmentsTab.deliveredOn")} text={item.delivered_on} />}
          {item.equipment_complete_status != "Picked Up" && item.pickup_by && (
            <ItemLabel label={t("OrdersTab.pickUpBy")} text={item.pickup_by} />
          )}
          {item.equipment_complete_status == "Picked Up" && item.picked_up_on && (
            <ItemLabel label={t("SilentTransfer.pickedUpOn")} text={item.picked_up_on} />
          )}
        </>
      )}
      {serviceOrderEquipment && item.service_request_reason_description && (
        <ItemLabel label={t("OrdersTab.serviceReasonLabel")} text={item.service_request_reason_description} />
      )}
      {serviceOrderEquipment && item.service_request_detail && (
        <ItemLabel label={t("OrdersTab.serviceNotesLabel")} text={item.service_request_detail} />
      )}
      {(serviceOrderEquipment && ((item.serviced_on != null && item.serviced_on != commonConstants.defaultDateTime) || (item.delivered_on != null && item.delivered_on != commonConstants.defaultDateTime) || (item.service_by != null && item.service_by != commonConstants.defaultDateTime))) && (
        <>
          {item.delivered_on && <ItemLabel label={t("EquipmentsTab.deliveredOn")} text={item.delivered_on} />}
          {item.equipment_complete_status != "Delivered" && item.service_by && (
            <ItemLabel label={t("OrdersTab.serviceBy")} text={item.service_by} />
          )}
          {item.equipment_complete_status == "Delivered" && item.serviced_on && (
            <ItemLabel label={t("OrdersTab.servicedOn")} text={item.serviced_on} />
          )}
        </>
      )}
      {item.reference_order_id !== 0 && (
        <ItemLabel label="Reference order">
          <Link to={`/orders/order-details/${item.reference_order_id}`}>
            {item.reference_order_id}
          </Link>
        </ItemLabel>
      )}
    </Stack>
  );
};

const EquipmentImageCard = ({ image, alt = "Equipment image" }) => (
  <Grid item xs={12} lg="auto" sx={{ mr: { lg: 4 }, mb: { xs: 2, lg: 0 } }}>
    <Card variant="outlined" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 1, width: { xs: '100%', lg: '10rem' } }}>
      {image === "" ? (
        <Icon icon="fa-box" style={{ width: "100%", maxWidth: "200px" }} />
      ) : (
        <img src={image} alt={alt} style={{ width: "100%", maxWidth: "200px" }} />
      )}
    </Card>
  </Grid>
);

const EquipmentListItem = ({ item, hideEquipmentImage, settingForBranch, t, details, actions }) => (
  <ListItem divider sx={{ py: 6 }}>
    <Grid container sx={{ flexWrap: { xs: 'wrap', lg: 'nowrap' } }}>
      {!hideEquipmentImage && <EquipmentImageCard image={item.equipment_image} />}
      <Grid item md={hideEquipmentImage ? 8 : 7} sm={6} xs={12}>
        <Stack spacing={3}>
          <Stack direction="row" sx={{ alignItems: "center", gap: 2 }}>
            <Typography variant="h6">{item.equipment_name}</Typography>
            <StatusBadge status={item?.equipment_complete_status} />
          </Stack>
          <GenericEquipmentTags item={item?.equipment_tags} settingForBranch={settingForBranch} />
          {details}
        </Stack>
      </Grid>
      {actions && (
        <Grid item md={4}>
          <Box className={styles.customButtonContainer1}>
            {actions}
          </Box>
        </Grid>
      )}
    </Grid>
  </ListItem>
);

const OrdersEquipment = () => {
  const [equipmentDataForOrders, setEquipmentDataForOrders] = useState([]);
  const [ordersStatus, setOrdersStatus] = useState("");
  const [serviceOrderEquipment, setServiceOrderEquipment] = useState([])
  const [pickupOrderEquipment, setPickupOrderEquipment] = useState([])
  const [quoteOrderEquipment, setQuoteOrderEquipment] = useState([]);
  const [isLoadingOrdersEquipment, setLoadingOrdersEquipment] = useState(true);
  const [isNoteForOrderEquipment, setOrderEquipment] = useState(false);
  const [cancelDetailsId, setCancelDetailsId] = useState(null)
  const [settingForBranch, setSettingForBranch] = useState(null)
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("sm"));
  const [hideEquipmentImage, setHideEquipmentImage] = useState(isMobile);
  const { t } = useTranslation();
  const location = useLocation();
  const [alertEquipemntName, setAlertEquipemntName] = useState(null);
  let showMessageForEquipment = `No equipment on this order.`;
  const userId = useSelector(state => state.authState.userData?.data?.user_info?.user_id); const navigate = useNavigate();
  const reasonCode = sessionStorage.getItem("reasonCode");
  const userRoles = useSelector(state => state.authState.userData?.data?.user_info?.role);
  const isReadOnly = userRoles?.is_read_only ? true : false;
  const fetchData = async () => {
    setLoadingOrdersEquipment(true);
    const requestBody = location.pathname.split('/').pop();
    const apiEndpoint = OrdersComponentApi.ordersEquipment.replace("{order_id}", requestBody).replace("{user_id}", userId);
    const response = await patientRequest(HTTPMethod.Get, apiEndpoint);
    if (response && response.status_code == 200 && response.data) {
      setOrdersStatus(response?.data?.order_data?.status?.trim());
      setEquipmentDataForOrders(response.data.order_equipment);
      setServiceOrderEquipment(response.data.service_order_equipment);
      setPickupOrderEquipment(response.data.pickup_equipments);
      setQuoteOrderEquipment(response.data.quote_equipments);
      handleBranchSettingsOrderEquipment(response.data);
    }
    setLoadingOrdersEquipment(false);
  };
  useEffect(() => {
    fetchData()
  }, []);

  const handleCancelEquipment = async () => {
    const cancelEquipmentPayload = {
      "order_detail_id": cancelDetailsId?.split(","),
      "order_id": location.pathname.split('/').pop()
    }

    const response = await patientRequest(
      HTTPMethod.Post,
      OrdersComponentApi.ordersCancelEquipment,
      cancelEquipmentPayload
    );

    if (response && response.status_code == 200) {
      const message = response?.return_message[0];
      successToast(message);
      setOrderEquipment(false);
      fetchData();
    }
  };

  const handleBranchSettingsOrderEquipment = async (equipmentData) => {
    const response = await patientRequest(HTTPMethod.Get, `${LocationStateApi.orderSettingsForBranch}?branch_id=${equipmentData?.order_data?.clientid}`);
    if (response && response.status_code == 200 && response.data) {
      setSettingForBranch(response.data.setting_list);
    }
  }

  const handleApproveOrder = () => {
    const order_id = location.pathname.split('/').pop();
    localStorage.setItem('approveOrder', 'listing');
    navigate("/order-approvals/order-approval-details/" + order_id);
  }

  return (
    <>
      <div data-testid="PatientsEquipment">
        {isLoadingOrdersEquipment ? (
          <Stack sx={{ gap: 8 }}>
            <Card>
              <EquipmentListSkeleton hideEquipmentImage={hideEquipmentImage} />
            </Card>
          </Stack>
        ) : (equipmentDataForOrders && equipmentDataForOrders?.length > 0) || (quoteOrderEquipment && quoteOrderEquipment?.length > 0) || (serviceOrderEquipment && serviceOrderEquipment?.length > 0) || (pickupOrderEquipment && pickupOrderEquipment?.length > 0) ? (
          <Stack>
            <ImageToggle hideEquipmentImage={hideEquipmentImage} setHideEquipmentImage={setHideEquipmentImage} />
            <Stack sx={{ gap: 8 }}>
              {equipmentDataForOrders && equipmentDataForOrders?.length > 0 &&
                <Panel title="Delivery" expandable data-testid="DMEItems">
                  <List disablePadding>
                    {equipmentDataForOrders?.map((item) => (
                      <EquipmentListItem
                        key={item.equipment_id}
                        item={item}
                        hideEquipmentImage={hideEquipmentImage}
                        settingForBranch={settingForBranch}
                        t={t}
                        details={<GenericEquipmentItemDetails item={item} orderStatus={item?.equipment_complete_status} t={t} equipmentDataForOrders={equipmentDataForOrders} />}
                        actions={<>
                          {(item?.equipment_complete_status === "Pending Approval" && item?.equipment_tags?.approval && item?.has_approval_access) && (
                            <Tooltip title="Approve Order">
                              <IconButton color="primary" onClick={handleApproveOrder}>
                                <Icon icon="fa-clipboard-check" />
                              </IconButton>
                            </Tooltip>
                          )}
                          {(!(item.can_be_cancel === false || (item.can_be_cancel === true && item?.equipment_complete_status === "Canceled")) && item.equipment_complete_status !== "Pending Approval" && item.equipment_complete_status !== "Not Approved" && reasonCode !== OrderReasonUpdatedEnum.Quote) && !isReadOnly && (
                            <Tooltip title="Cancel Equipment">
                              <IconButton color="error" onClick={() => {
                                setOrderEquipment(true);
                                setCancelDetailsId(item.order_detail_id || item.order_detail_ids);
                                setAlertEquipemntName(item.equipment_name);
                              }}>
                                <Icon icon="fa-xmark" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </>}
                      />
                    ))}
                  </List>
                </Panel>
              }
              {quoteOrderEquipment && quoteOrderEquipment?.length > 0 &&
                <Panel title="Quote" expandable data-testid="DMEItems">
                  <List disablePadding>
                    {quoteOrderEquipment?.map((item) => (
                      <EquipmentListItem
                        key={item.equipment_id}
                        item={item}
                        hideEquipmentImage={hideEquipmentImage}
                        settingForBranch={settingForBranch}
                        t={t}
                        details={<GenericEquipmentItemDetails item={item} orderStatus={item?.equipment_complete_status} t={t} />}
                        actions={
                          !(item.can_be_cancel === false || (item.can_be_cancel === true && item?.equipment_complete_status === "Canceled")) && (!item?.equipment_complete_status?.includes("Provider Quote") && !item?.equipment_complete_status?.includes("StateServ Audit") && !item?.equipment_complete_status?.includes("Client Review") && item.equipment_complete_status !== "Not Approved") && !isReadOnly && (
                            <Tooltip title="Cancel Equipment">
                              <IconButton color="error" onClick={() => {
                                setOrderEquipment(true);
                                setCancelDetailsId(item.order_detail_id || item.order_detail_ids);
                                setAlertEquipemntName(item.equipment_name);
                              }}>
                                <Icon icon="fa-xmark" data-testid="CancelEquipment" />
                              </IconButton>
                            </Tooltip>
                          )
                        }
                      />
                    ))}
                  </List>
                </Panel>
              }

              {serviceOrderEquipment && serviceOrderEquipment?.length > 0 &&
                <Panel title="Service" expandable data-testid="ServiceOrderEquipment">
                  <List disablePadding>
                    {serviceOrderEquipment?.map((item) => (
                      <EquipmentListItem
                        key={item.equipment_id}
                        item={item}
                        hideEquipmentImage={hideEquipmentImage}
                        settingForBranch={settingForBranch}
                        t={t}
                        details={<GenericEquipmentItemDetails item={item} orderStatus={item?.equipment_complete_status} t={t} serviceOrderEquipment={serviceOrderEquipment} />}
                        actions={
                          (ordersStatus === orderStatus.Received && !(item.can_be_cancel === false || (item.can_be_cancel === true && (item?.equipment_complete_status === "Canceled" || item?.equipment_complete_status === "Delivered"))) && item.equipment_complete_status != "Pending Approval" && item.equipment_complete_status != "Not Approved") && !isReadOnly && (
                            <Tooltip title="Cancel Equipment">
                              <IconButton color="error" onClick={() => {
                                setOrderEquipment(true);
                                setCancelDetailsId(item.order_detail_id || item.order_detail_ids);
                                setAlertEquipemntName(item.equipment_name);
                              }}>
                                <Icon icon="fa-xmark" />
                              </IconButton>
                            </Tooltip>
                          )
                        }
                      />
                    ))}
                  </List>
                </Panel>}

              {pickupOrderEquipment && pickupOrderEquipment?.length > 0 &&
                <Panel title="Pick up" expandable data-testid="pickupOrderEquipment">
                  <List disablePadding>
                    {pickupOrderEquipment?.map((item) => (
                      <EquipmentListItem
                        key={item.equipment_id}
                        item={item}
                        hideEquipmentImage={hideEquipmentImage}
                        settingForBranch={settingForBranch}
                        t={t}
                        details={<GenericEquipmentItemDetails item={item} orderStatus={item?.equipment_complete_status} t={t} pickupOrderEquipment={pickupOrderEquipment} />}
                        actions={
                          (!(item.can_be_cancel === false || (item.can_be_cancel === true && item?.equipment_complete_status === "Canceled")) && item.equipment_complete_status != "Pending Approval" && item.equipment_complete_status != "Not Approved") && !isReadOnly && (
                            <Tooltip title="Cancel Equipment">
                              <IconButton color="error" onClick={() => {
                                setOrderEquipment(true);
                                setCancelDetailsId(item.order_detail_id || item.order_detail_ids);
                                setAlertEquipemntName(item.equipment_name);
                              }}>
                                <Icon icon="fa-xmark" />
                              </IconButton>
                            </Tooltip>
                          )
                        }
                      />
                    ))}
                  </List>
                </Panel>
              }

            </Stack>
          </Stack>
        ) :
          (<Stack alignItems="center" justifyContent="center" sx={{ mt: '50px' }}><NoData message={showMessageForEquipment} /></Stack>)
        }
        <CommonAlert
          isOpen={isNoteForOrderEquipment} handleCancel={() => { setOrderEquipment(false); }} handleSubmit={handleCancelEquipment}
          contentText={` Are you sure you want to cancel the equipment   ${alertEquipemntName}?`}
          okButtonStyle="red" headerText="Cancel Equipment" cancelText="Go back" okText="Proceed" />
      </div>
    </>
  );
};


export default OrdersEquipment;
